import { JsonSchemaForm } from './schema_form_generator/schema_form_generator.directive';
import { SchemaFormDatePicker } from './schema_form_date_picker/schema_form_date_picker.directive';
import { SchemaFormExternalResourceSelector } from './schema_form_external_resource_selector/schema_form_external_resource_selector.directive';
import { SchemaFormCheckbox } from './schema_form_checkbox/schema_form_checkbox.directive';
import { SchemaFormExternalResourceSelectorController } from './schema_form_external_resource_selector/schema_form_external_resource_selector.controller';
import { QueryBuilder } from '../../services/query-builder.service';

export const initialise = () => {
  angular.module('schemaForm').config(['schemaFormProvider',
    'schemaFormDecoratorsProvider', 'sfPathProvider', 'schemaFieldsThatNeedSpecialControls',
    (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider, schemaFieldsThatNeedSpecialControls) => {
      // Set up property combination that will trigger this directive
      const date = (name, schema, options) => {
        if (schema.type === 'string' && schema.format === 'date') {
          const f = schemaFormProvider.stdFormObj(name, schema, options);
          f.key = options.path;
          f.type = 'date';
          options.lookup[sfPathProvider.stringify(options.path)] = f;
          return f;
        }
      };

      // Add our default to the defaults array
      schemaFormProvider.defaults.string.unshift(date);

      //These can be loaded from a file or made external so its easy to add more. The ideal solution is that the schema
      //will contain something that we can lookup
      const isSpecialField = (fieldName) => {
        return schemaFieldsThatNeedSpecialControls.some((specialField) => {
          return specialField.name === fieldName;
        });
      };

      const externalResourceLookup = (name, schema, options) => {
        if (schema.type === 'string' && isSpecialField(schema.title)) {
          const f = schemaFormProvider.stdFormObj(name, schema, options);
          f.key = options.path;
          f.type = 'external-resource';
          options.lookup[sfPathProvider.stringify(options.path)] = f;
          return f;
        }
      };
      schemaFormProvider.defaults.string.unshift(externalResourceLookup);

      const checkbox = (name, schema, options) => {
        if (schema.type === 'boolean') {
          const f = schemaFormProvider.stdFormObj(name, schema, options);
          f.key = options.path;
          f.type = 'boolean';
          options.lookup[sfPathProvider.stringify(options.path)] = f;
          return f;
        }
      };

      schemaFormProvider.defaults.boolean.unshift(checkbox);

      // Second, we want it to show if someone have explicitly set the form type
      schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'date',
        'app/angularJS/components/json_schema_form/schema_form_date_picker/schema_form_date_picker.html');

      schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'boolean',
        'app/angularJS/components/json_schema_form/schema_form_checkbox/schema_form_checkbox.html');

      schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'external-resource',
        'app/angularJS/components/json_schema_form/schema_form_external_resource_selector/schema_form_external_resource_selector.html');
    }])
    .directive('actJsonSchemaForm', () => { return new JsonSchemaForm(); })
    .directive('schemaFormDatePickerDirective', ['$filter', ($filter) => { return new SchemaFormDatePicker($filter); }])
    .directive('schemaFormCheckboxDirective', ['$filter', ($filter) => { return new SchemaFormCheckbox($filter); }])
    .directive('schemaFormExternalResourceSelector', ['$filter', ($filter) => { return new SchemaFormExternalResourceSelector($filter); }])
    .controller('schemaFormExternalResourceSelectorController', <any>SchemaFormExternalResourceSelectorController)
    .constant('schemaFieldsThatNeedSpecialControls', [{
      name: 'Timeband',
      endpoint: 'timebands',
      responseFieldThatContainsResources: 'timebands',
      responseFieldThatContainsIndividualResource: 'timeband',
      displayNamePath: 'name',
      getDisplayName: (timeband: InterACT.Interfaces.Timebands.Timeband) => {
        return timeband.name ? timeband.name : '';
      }
    }, {
      name: 'Operator',
      endpoint: 'transport-operators',
      responseFieldThatContainsResources: 'transportOperators',
      displayNamePath: 'name.en',
      getDisplayName: (transportOperator: InterACT.Interfaces.TransportOperators.TransportOperator) => {
        return transportOperator.name && transportOperator.name.en ? transportOperator.name.en : '';
      }
    }, {
      name: 'Zone',
      endpoint: 'transport-zones',
      responseFieldThatContainsResources: 'transportZones',
      responseFieldThatContainsIndividualResource: 'transportZone',
      displayNamePath: 'name',
      getDisplayName: (transportZone: InterACT.Interfaces.TransportZones.TransportZone) => {
        return transportZone.name ? transportZone.name : '';
      }
    }, {
      name: 'Service',
      endpoint: 'transport-operator-services',
      responseFieldThatContainsResources: 'transportOperatorServices',
      displayNamePath: 'registrationNumber',
      getDisplayName: (transportOperatorService: InterACT.Interfaces.TransportOperatorServices.TransportOperatorService) => {
        return transportOperatorService.registrationNumber ? transportOperatorService.registrationNumber + ' (' + transportOperatorService.serviceNumber + ')' : '';
      }
    },
    {
      name: 'Entitlement',
      endpoint: 'search-results',
      responseFieldThatContainsResources: 'searchResults',
      displayNamePath: 'name',
      buildAdditionalQuery: (queryBuilder: QueryBuilder) => {
        const now: string = new Date().toISOString().substr(0, 16) + 'Z';
        queryBuilder
          .and()
          .fieldIs('type', 'VARIANT')
          .and()
          .fieldIs('schema', 'ABT_ENTITLEMENT')
          .and()
          .fieldIs('status', 'AUTHORISED')
          .and()
          .isLessThanOrEqualTo('effectiveFrom', now)
          .and()
          .openSubQuery()
          .not()
          .exists('effectiveTo')
          .or()
          .isGreaterThan('effectiveTo', now)
          .closeSubQuery()
      },
      getDisplayName: (searchResult: InterACT.Interfaces.ProductSearch.SearchResult) => {
        return searchResult.name ? searchResult.name : '';
      }
    }])
    .constant('serviceEndpointToServiceNameDictionary', {
      'transport-operators': 'transportOperatorService',
      'transport-operator-services': 'transportOperatorBusRouteService',
      'transport-zones': 'transportZoneService',
      'timebands': 'timebandService',
      'search-results': 'productSearchService'
    });
};
